import { Component, Prop, Host, h } from '@stencil/core';

@Component({
  tag: 'spw-field-message',
  styleUrl: 'spw-field-message.scss',
  shadow: true,
})
export class SpwFieldMessage {
  /** Permet d'afficher ou pas une icône dans le message */
  @Prop() showIcon?: boolean = true;
  /** Choix du variant du message */
  @Prop() variant?: 'error' | 'hint' | 'success';

  private get variantIcon(): string {
    switch (this.variant) {
      case 'error':
        return 'fa-warning';
      case 'hint':
        return 'fa-exclamation-circle';
      case 'success':
        return 'fa-check-circle';
      default:
        return '';
    }
  }

  private get elementClass(): { [className: string]: boolean } {
    return {
      'spw-field-message': true,
      [`spw-field-message--${this.variant}`]: true,
    };
  }

  render() {
    return (
      <Host>
        <div class={this.elementClass}>
          {this.showIcon && (
            <div class="spw-field-message__icon">
              <spw-icon icon={this.variantIcon}></spw-icon>
            </div>
          )}
          <span class="spw-field-message__text">
            <slot></slot>
          </span>
        </div>
      </Host>
    );
  }
}
